<template>
	<div class="selectSignatory">
		<el-dialog :title="title" :visible.sync="dialog.show" :width="width" @close="handclose" center :close-on-click-modal="false">
			<div class="center">
				<el-form ref="form" class="lz-seach-animation" inline @submit.native.prevent>
					<el-form-item label="申请单名称">
						<el-input v-model="seachData.title" placeholder="申请单名称" @keyup.enter.native="seachInput" clearable></el-input>
					</el-form-item>
					<!-- <el-form-item label="合同编号">
						<el-input v-model="seachData.serialNumber" placeholder="合同编号" @keyup.enter.native="seachInput" clearable></el-input>
					</el-form-item> -->
					<el-form-item label="创建日期">
						<el-date-picker
						      v-model="seachData.dateList"
						      type="datetimerange"
						      :picker-options="pickerOptions"
						      range-separator="至"
						      start-placeholder="开始日期"
						      end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"
						      align="right" @change="changeDatePicker">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-search" plain size="small" type="primary" @click="seachInput">搜索</el-button>
					</el-form-item>
				</el-form >
				<el-table :data="tableData" style="width: 100%" border>
					<el-table-column align="center" label="创建时间" prop="createDate" width="140"></el-table-column>
					<el-table-column :show-overflow-tooltip="true" align="center" label="合同编号" prop="serialNumber"></el-table-column>
					<el-table-column :show-overflow-tooltip="true" align="center" label="申请单名称" prop="title"></el-table-column>
					<el-table-column :show-overflow-tooltip="true" align="center" label="发起方" prop="originateEnterprise">
						<template slot-scope="scope">
							{{scope.row.originateUser}}【{{scope.row.originateEnterprise}}】
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip="true" align="center" label="待处理" prop="enterpriseName"></el-table-column>
					<el-table-column align="center" label="签署方" prop="liaisonSignContentList">
						<template slot-scope="scope">
							<div v-for="(item,index) in scope.row.liaisonSignContentList" :key="index" style="margin-bottom: 5px;">
								<el-tag type="info" >{{item.name}}</el-tag>
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="签署状态" prop="status" width="80">
						<template slot-scope="scope">
							<div v-for="(item,index) in scope.row.liaisonSignContentList" :key="index" style="margin-bottom: 5px;">
								<el-tag :type="computedTypeId(item.status)">{{computedTypeId(item.status,'text')}}</el-tag>
							</div>
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip="true" align="center" fixed="right" label="操作" width="120">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="submitFn(scope.row)">加盖电子章</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination :current-page="page.pageNum" :page-size="page.pageSize" :page-sizes="[10,20,30,40,50]"
				:total="page.total" class="lz-el-pagination" layout="total, sizes, prev, pager, next, jumper"
				@current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>
			</div>
		</el-dialog>
		
		
	</div>
</template>

<script>
	let that 
	import {
		mapGetters
	} from 'vuex'

	export default {
		computed: {
			...mapGetters(['api']),
			computedTypeId() {
				return (typeId,type) => {
					let arr = this.contractStatusList.find(item => item.key == typeId)
					if (arr) {
						return type=='text'? arr.value : arr.color
					} else {
						return  type=='text'? '待定' : 'info' 
					}
				}
			}
		},
		name: 'selectSignatory',
		props: {
			close:{type:Function},
			confirm: {type:Function},
			cancel: {type:Function},
			width: {
				type: String,
				default: '80%'
			},
			title: {
				type: String,
				default: '选择'
			},
			enterpriseId:{
				type: String,
				default: ''
			}
		},
		data() {
			return {
				// 签署状态  initiate:初始化状态  waiting:待提取  extracted:待签署  processing:待审批  authorizing:待授权  using:待用印  completed:已完成  failure:已失效  refused:已拒绝  expired:已过期
				contractStatusList:[],
				dialog:{
					show:false,
				},
				tableData:[],
				//搜索
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				//搜索
				seachData: {
					status:'owner',//合同状态 launched:已发起 owner:待我签 other:待他签 completed:已完成 refused:已拒绝 expired:已过期
					title: '' ,//合同标题
					serialNumber:'',//合同编号
					dateList:'',//创建日期
					start:'',
					end:''
				},
				page:{
					page: true,
					pageNum: 1,
					pageSize: 10,
					total:0
				},
				selectList:[],//已经选择的
			}
		},
		mounted() {
			that =this
		},
		methods: {
			//获取合同状态
			findEnterpriseContractStatusList(){
				that.GLOBAL.doGet(this.api.GLOBAL_electronic_helper_findEnterpriseContractStatusList,{},(res)=>{
					if(res.code==200&&res.data){
						this.contractStatusList=res.data
					}else{
						this.contractStatusList=[]
					}
				})
			},
			//选择日期
			changeDatePicker(data){
				console.log(data);
				if(data){
					this.seachData.start=data[0]
					this.seachData.end=data[1]
				}else{
					this.seachData.start=''
					this.seachData.end=''
				}
			},
			cancelFn(){
				this.dialog.show=false
				this.cancel()
			},
			//确定
			submitFn(row){
				this.dialog.show=false
				this.confirm(row)
			},
			//多选
			handleSelectionChange(val){
				this.selectList=val
			},
			seachInput(){
				this.findList()
			},
			show(data){
				this.dialog.show=true
				this.findList()
				this.findEnterpriseContractStatusList()
			},
			findList(){
				let req={
					enterpriseId:this.enterpriseId,
					...this.page,
					...this.seachData
				}
				that.GLOBAL.doGet(this.api.GLOBAL_electronic_enterprise_application_findAvailableContractList,req,(res)=>{
					if(res.code==200&&res.data){
						this.tableData=res.data.list
						this.page.total=res.data.total
					}else{
						this.tableData=[]
						this.page.total=0
					}
				})
			},
			handclose(){
				this.close()
			},
			handleCurrentChange(val){
				that.page.pageNum = val;
				that.findList()
			},
			handleSizeChange(val){
				that.page.pageSize = val;
				that.findList()
			}
			
		}
	}
</script>

<style lang="scss" scoped>
	/deep/ .el-dialog--center .el-dialog__body{
		padding:20px 20px 0px
	}
	.selectSignatory {
		.center{
			overflow: hidden;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/selectContract/selectContract.vue